
import React, { Component } from "react";
import { Box, Textarea, Button, Select, HStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRandom } from "@fortawesome/free-solid-svg-icons";
import he from 'he'

import Dictaphone from "../../../../components/lib/Dictaphone/GcDictaphone";

import TranslationService from "../../../../services/TranslationService";



const langOptions =
    [
        { label: 'english', value: 'en' },
        { label: 'espanol', value: 'es' },
        { label: 'japanese', value: 'ja' },
        { label: 'korean', value: 'ko' },
        { label: 'french', value: 'fr' },
        { label: 'norsk', value: 'no' },
        { label: 'filipino', value: 'tl' },
        { label: 'chinese', value: 'zh-CN' },
        { label: 'chinese (trad)', value: 'zh-TW' },
        { label: 'dutch', value: 'nl' },
        { label: 'persian', value: 'fa' },
        { label: 'polish', value: 'pl' },
        { label: 'swahili', value: 'sw' }
    ]

export default class TextEditInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            translateFrom: null,
            translateTo: null,
            value: ''
        }

        this.translationService = new TranslationService();

        this.onTranscriptionChange = this.onTranscriptionChange.bind(this);
        this.translateText = this.translateText.bind(this);
        this.onLangChange = this.onLangChange.bind(this);

        this.onTextChange = this.onTextChange.bind(this);
    }


    onTranscriptionChange(newTranscription) {
        var newValue = (this.props.cardValue) ? this.props.cardValue + " " + newTranscription : newTranscription;
        this.props.onValueChange(newValue, this.props.card.id);
        this.setState({
            value: newValue
        })
    }

    onLangChange(e, direction) {
        // var langState = {};
        // langState[opt.id] = opt.value;
        if(direction === "to"){
            this.setState({
                translateTo: e.target.value
            })
        } else if (direction === "from"){
            this.setState({
                translateFrom: e.target.value
            })
        }
        
    }

    async translateText() {
        if ((this.props.cardValue) && (this.props.cardValue !== '')) {
            var translationResponse = await this.translationService.translateTo(this.state.translateTo, this.props.cardValue, this.props.gcid, this.props.token);
            var newText = (translationResponse?.dataResult?.data) ? he.decode(translationResponse.dataResult.data.translateResults[0].translatedText) : "unable to translate";
            console.log("newText: " + newText);
            this.setState({
                value: newText
            })
            this.props.onValueChange( newText, this.props.card.id);
        }
    }

    onTextChange(e){
        var newValue = e.target.value;
        this.setState({
            value: newValue
        })
        this.props.onValueChange(newValue, this.props.card.id);
    }

    render() {
        
        return (
            <Box >

                {(this.props.onlineInfo.isConnected) &&
                <HStack padding='10px'>
         
                    <Dictaphone
                        lang={this.state.translateFrom}
                        onTranscriptionChange={this.onTranscriptionChange}
                        
                    />
                    

                    <Select

                        id="translateFrom"
                        name="translateFrom"
                        placeholder={this.state.translateFrom}
                        value={this.state.translateFrom}
                        // options={langOptions}
                        onChange={(e) => this.onLangChange(e, "from")}
                        backgroundColor='white'
                    >
                        {langOptions.map((lang) => (
                            <option key={lang.id} value={lang.id}>{lang.label}</option>
                        ))}
                    </Select>
                    <Button
                        id="translateButton"
                        disabled={!this.props.cardValue}
                        variant="secondary"
                        onClick={this.translateText}
                        leftIcon={<FontAwesomeIcon id="translate" icon={faRandom} size="2x" color={(this.props.cardValue) ? "green" : "lightgrey"} />}
                    />

                    <Select
                        id="translateTo"
                        name="translateTo"
                        placeholder={this.state.translateTo}
                        // value={this.state.translateTo}
                        // options={langOptions}
                        onChange={e => this.onLangChange(e, "to")}
                        backgroundColor='white'
                    >
                        {langOptions.map((lang) => (
                            <option key={lang.value} value={lang.value}>{lang.label}</option>
                        ))}
                    </Select>
                </HStack>
                }

                <Textarea
                    autoFocus
                    size='md'
                    resize='vertical'
                    backgroundColor='white'
                    value = {this.state.value}
                    onChange={(e) => this.onTextChange(e)}
                />

            </Box>


        )
    }
}







